// extracted by mini-css-extract-plugin
export default {"test_card":"PartSurveyReport_test_card__7C9AJ","btn_print":"PartSurveyReport_btn_print__QpvbJ","div_print":"PartSurveyReport_div_print__928kx"};